import React, { useState, useEffect } from 'react';
import RecycleImageSlider from './RecycleImageSlider';
import RecycleOffersSlider from './RecycleOffersSlider';
// Note: CSS should be imported in your main HTML file or via build tool
// import '../assets/css/sustainable-future.css';

const recycleOffersFallback = [
    {
        id: 1,
        type: 'Recycled HDPE',
        product: 'HDPE Recycled Pellets - Grade A',
        price_display: '₹82,500 - ₹84,200',
        quantity: '25 MT',
        location: 'Mumbai Port',
        grade: 'Grade A',
        country_origin: 'India',
        form_of_material: 'Pellets',
        process_type: 'Extrusion',
        color: 'Natural',
        mfi: 'N/A',
        packaging: 'Bags'
    },
    {
        id: 2,
        type: 'Recycled PP',
        product: 'PP Recycled Granules - Food Grade',
        price_display: '₹89,300 - ₹91,000',
        quantity: '15 MT',
        location: 'Chennai Port',
        grade: 'Food Grade',
        country_origin: 'India',
        form_of_material: 'Granules',
        process_type: 'Injection',
        color: 'Natural',
        mfi: 'N/A',
        packaging: 'Bags'
    },
    {
        id: 3,
        type: 'Recycled PET',
        product: 'PET Recycled Flakes - Clear',
        price_display: '₹76,800 - ₹78,500',
        quantity: '30 MT',
        location: 'JNPT Mumbai',
        grade: 'Premium Grade',
        country_origin: 'India',
        form_of_material: 'Flakes',
        process_type: 'Blow Molding',
        color: 'Clear',
        mfi: 'N/A',
        packaging: 'Bags'
    },
    {
        id: 4,
        type: 'Recycled LDPE',
        product: 'LDPE Recycled Pellets - Film Grade',
        price_display: '₹85,000 - ₹87,500',
        quantity: '20 MT',
        location: 'Kandla Port',
        grade: 'Film Grade',
        country_origin: 'India',
        form_of_material: 'Pellets',
        process_type: 'Blown Film',
        color: 'Natural',
        mfi: '2.0 g/10min',
        packaging: 'Bags'
    },
    {
        id: 5,
        type: 'Recycled PVC',
        product: 'PVC Recycled Granules - Rigid',
        price_display: '₹92,000 - ₹95,000',
        quantity: '18 MT',
        location: 'Mundra Port',
        grade: 'Rigid Grade',
        country_origin: 'India',
        form_of_material: 'Granules',
        process_type: 'Extrusion',
        color: 'White',
        mfi: 'N/A',
        packaging: 'Bags'
    },
    {
        id: 6,
        type: 'Recycled ABS',
        product: 'ABS Recycled Pellets - Injection Grade',
        price_display: '₹1,15,000 - ₹1,18,000',
        quantity: '12 MT',
        location: 'Nhava Sheva Port',
        grade: 'Injection Grade',
        country_origin: 'India',
        form_of_material: 'Pellets',
        process_type: 'Injection',
        color: 'Black',
        mfi: '15-20 g/10min',
        packaging: 'Bags'
    }
];

const recycleImages = [
    '/assets/images/recycle/recycle3.webp',
    '/assets/images/recycle/product_recycle.webp',  
    '/assets/images/recycled/image.png',
    // '/assets/images/recycle/product_recycle1.webp'
];

const RecycleSection = () => {
    const [offers, setOffers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [hasOffers, setHasOffers] = useState(false);

    useEffect(() => {
        loadRecycledOffers();
    }, []);

    const loadRecycledOffers = async () => {
        try {
            // Use fallback data directly (static offers)
            let loadedOffers = [...recycleOffersFallback];

            // If we have very few offers (less than 3), duplicate them to enable slider functionality
            if (loadedOffers.length > 0 && loadedOffers.length < 3) {
                const originalCount = loadedOffers.length;
                const needed = 3 - originalCount;
                for (let i = 0; i < needed; i++) {
                    const offer = loadedOffers[i % originalCount];
                    loadedOffers.push({
                        ...offer,
                        id: offer.id + 1000 + i,
                        location: offer.location + (i > 0 ? ' ' + (i + 1) : '')
                    });
                }
            }
            setOffers(loadedOffers);
            setHasOffers(loadedOffers.length > 0);
            setLoading(false);
        } catch (error) {
            console.error('Error loading recycled offers:', error);
            setOffers(recycleOffersFallback);
            setHasOffers(recycleOffersFallback.length > 0);
            setLoading(false);
        }
    };

    const handleAppDownload = (type) => {
        if (typeof window !== 'undefined' && window.handleAppDownload) {
            window.handleAppDownload(type);
        } else {
            console.log('Download app:', type);
        }
    };

    return (
        <section id="sustainable-recycle" className="sustainable-future-section">
            <div className="container">
                <div className="section-header sustainable-header">
                    <div>
                        <h2 style={{ textAlign: 'left' }}>Sustainable Future Starts Today.</h2>
                        <p style={{ textAlign: 'left' }}>Explore high-quality Recycle Grades and purchase with confidence.</p>
                    </div>
                </div>

                <div className="sustainable-main-grid">
                    {/* Left Side: Recycle Impact - Images Only */}
                    <RecycleImageSlider 
                        images={recycleImages}
                        onDownloadApp={() => handleAppDownload('buyer')}
                    />

                    {/* Right Side: Recycled Polymer Lots – shows offers or clean empty state when no offers */}
                    <RecycleOffersSlider 
                        offers={offers}
                        loading={loading}
                    />
                </div>
            </div>
        </section>
    );
};

export default RecycleSection;
